import { createApp } from 'vue';
import App from './App.vue';
import Translation from '@/libraries/Translation';

createApp(App)
  .mixin({
    methods: {
      __(key, replace) {
        return Translation(key, replace);
      }
    }
  })
  .mount('#roomRent');
